module.exports = __webpack_public_path__ + "static/img/5752.44c011b0.png";